import React from "react";

/**
 * Branded loading fallback for React.lazy + Suspense.
 * Matches Isaiah's World cosmic design language.
 *
 * Usage:
 *   <Suspense fallback={<LoadingFallback section="Learn" />}>
 *     <LazyComponent />
 *   </Suspense>
 */
export default function LoadingFallback({ section }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="loading-fallback">
      <div className="text-center">
        {/* Orbital animation */}
        <div className="relative w-16 h-16 mx-auto mb-5">
          <div className="absolute inset-0 rounded-full border-2 border-blue-500/20 animate-ping" style={{ animationDuration: "1.5s" }} />
          <div className="absolute inset-2 rounded-full border-2 border-t-blue-400 border-r-transparent border-b-transparent border-l-transparent animate-spin" style={{ animationDuration: "0.8s" }} />
          <div className="absolute inset-4 rounded-full bg-blue-500/10 flex items-center justify-center">
            <div className="w-2 h-2 rounded-full bg-blue-400" />
          </div>
        </div>
        {section && (
          <p className="text-white/30 text-xs font-nunito tracking-wide animate-pulse">
            Loading {section}...
          </p>
        )}
      </div>
    </div>
  );
}
